import React, { useEffect } from 'react';
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useRecoilState } from 'recoil';
import { hcbswordStatusState } from '../../../globalStates/item/hcbswordStatus';
import { hcbWindowDisplayState } from '../../../globalStates/item/hcbWindowDisplay';
import { useMedia } from 'use-media';


const HcbSwordWindow = (props) => {
  const [hcbSwordStatus, setHcbSwordStatus] = useRecoilState(hcbswordStatusState);
  const isPC = useMedia({ minWidth: '1000px' });
  const isTablet = useMedia({ minWidth: '1000px', maxWidth: '1400px' });
  const windowArea = css`
    display: ${props.hcbDisplay};
    position: absolute;
    top: ${isTablet ? "-10px" : "0"};
    left: ${isTablet ? "-100px" : "0"};
    /* transform: translate(-50%, -50%); */
    width: ${isPC ? "35vw" : "100vw"};
    height: ${isPC ? "calc(100vh - 150px)" : "100vh"};

    -webkit-backdrop-filter: blur(3px);
    backdrop-filter: blur(3px);
    background-color: rgba(191, 212, 235, 0.5);
    z-index: 20;
    .wordArea {
      animation-name: fadeInAnime;
      animation-duration: 0.5s;
      animation-fill-mode:forwards;
      opacity: 0;
      @keyframes fadeInAnime{
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }
      color: #323232;
      filter: drop-shadow(3px 3px 5px rgba(0,0,0,0.7));
      position: absolute;
      top: 45%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #ffffffa1;
      text-align: center;
      width: ${isPC ? "20vw" : "70vw"};
      height: 180px;
      h3 {
          margin-top: 30px;
        }
      .button-area {
          display: flex;
          justify-content: center;
        button {
          border-radius: 8px;
          cursor: pointer;
          margin-top: 20px;
          margin-right: 30px;
          margin-left: 30px;
          width: 110px;
          height: 50px;
        }
      }
    }
  `;
  useEffect(() => {
    if (props.hcbDisplay === "block") {
      if (document.querySelector(".fieldArea")) {
        document.querySelector(".fieldArea").style.display = "none";
      }
    } else {
      if (document.querySelector(".fieldArea")) {
        document.querySelector(".fieldArea").style.display = "block";
      }
    }
  }, [props.hcbDisplay]);

  const handleClick = (selectBtn) => {
    setHcbSwordStatus(selectBtn);
  }

  return (
    <>
      <div css={windowArea}>
        <div className='wordArea'>
          <h3>どちらを使いますか？</h3>
          <div className='button-area'>
            <button onClick={() => handleClick("warp")}>ワープ</button>
            <button onClick={() => handleClick("reverse")}>リバース</button>
          </div>
        </div>
      </div>
    </>
  )
}

export default HcbSwordWindow
